import { Component } from 'react';

import * as styles from './styles';

interface IProps {
  width?: string;
  height?: string;
  inline?: boolean;
}

interface IState {
  hasError: boolean;
}

export const IconPlaceholder = (props: IProps) => {
  return <div className={styles.placeholderStyles(props)} />;
};

export class IconErrorBoundary extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <IconPlaceholder {...this.props} />;
    }

    return this.props.children;
  }
}
